import DOMPurify from 'dompurify';
import { BROADCAST_HTML_SANITIZE_CONFIG } from './markdownSanitizeConfig.js';
import { renderSanitizedMarkdown } from './markdownToHtml.js';
import { swapUnsubscribePlaceholder } from './emailUnsubscribeTag.js';

// Browser-side broadcast email HTML sanitiser for the compose page's live
// preview. Uses DOMPurify against the global window (native DOM). Shares the
// BROADCAST_HTML_SANITIZE_CONFIG allow-list with the server sanitiser so the
// preview pane renders exactly what the franchisee will receive.
//
// Browser-only — never import this from server code (the server uses
// server/lib/sanitizeHtml.ts, which binds DOMPurify to a jsdom window). Keeping
// the two split ensures jsdom never leaks into the client bundle.

export function sanitizeBroadcastHtmlClient(html: string): string {
  return DOMPurify.sanitize(html, BROADCAST_HTML_SANITIZE_CONFIG);
}

export function renderBroadcastEmailHtmlClient(markdown: string): string {
  return swapUnsubscribePlaceholder(renderSanitizedMarkdown(markdown, sanitizeBroadcastHtmlClient), '#');
}
